import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './Components/Elements/Headers/Headers';
import Footer from './Components/Elements/Footer/Footer';
import ContactSection from './Components/Elements/ContactsSection/ContactSection';
import Solution from './Components/Elements/Solutions/Solutions';
import Hero from './Components/Elements/Hero/Hero';
import Services from './Components/Elements/Services/Services';
import ProjectsGallery from './Components/Elements/ProjectsGallery/ProjectsGallery';
import ProjectProcess from './Components/Elements/ProjectProcess/ProjectProcess';
import WhyChooseUs from './Components/Elements/WhyChooseUs/WhyChooseUs';
import SroSection from './Components/Elements/SroSection/SroSection';
import FaqSection from './Components/Elements/FaqSection/FaqSection';
import AdminPanel from './Components/AdminPanel/AdminPanel';

/* ── Главная страница сайта ── */
function MainPage() {
  return (
    <>
      <Header />
      <Hero />
      <Solution />
      <Services />
      <ProjectProcess />
      <WhyChooseUs />
      <SroSection />
      <ProjectsGallery />
      <FaqSection />
      <ContactSection />
      <Footer />
    </>
  );
}

/* ── Корень приложения с роутингом ── */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/admin" element={<AdminPanel />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;